export default __webpack_public_path__ + "static/media/background.2adfd36c.png";